module.exports = __webpack_public_path__ + "img/video_3.ce197fc5.jpg";